import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { INITIAL_CONFIGS } from '~/features/admin/constants';

import { SliceType } from '../types';
import { ClientsState as State } from './types';

const initialState: State = {
  action: null,
  client: null,
  configs: INITIAL_CONFIGS,
};

const setConfigurationReducer = (
  state: Partial<State>,
  action: PayloadAction<Partial<State>>,
) => {
  state.action = action.payload.action;
  state.client = action.payload.client;
  state.configs = action.payload.configs || INITIAL_CONFIGS;
};

export default createSlice({
  name: SliceType.Clients,
  initialState,
  selectors: {
    selectAction: (state) => state.action,
    selectClient: (state) => state.client,
    selectConfigs: (state) => state.client,
    selectConfiguration: ({ action, client, configs }) => ({
      configs,
      action,
      client,
    }),
  },
  reducers: {
    setAction: (state, action: PayloadAction<State['action']>) => {
      state.action = action.payload;
    },
    setClient: (state, action: PayloadAction<State['client']>) => {
      state.client = action.payload;
    },
    setConfigs: (state, action: PayloadAction<State['configs']>) => {
      state.configs = action.payload;
    },
    patchConfigs: (state, action: PayloadAction<Partial<State['configs']>>) => {
      state.configs = {
        ...state.configs,
        ...action.payload,
      };
    },
    setConfiguration: setConfigurationReducer,

    resetConfiguration: (state) => {
      state.action = null;
      state.client = null;
      state.configs = INITIAL_CONFIGS;
    },
  },
});
